import { ThunkAction } from 'redux-thunk'
import { RootState } from '..'
import { workScheduleApi } from '../../apis'
import {
  WorkScheduleEntity,
  WorkScheduleFilter,
} from '../../models/workSchedule/workSchedule'
import {
  SET_SELECTED_WORK_SCHEDULE,
  SET_WORK_SCHEDULES,
  SET_WORK_SCHEDULES_LOADED,
  SET_WORK_SCHEDULE_FILTER,
  WorkScheduleAction,
} from '../types'
import { loadProfile } from './authAction'

export const setWorkSchedules = (
  workSchedules: WorkScheduleEntity[]
): WorkScheduleAction => ({
  type: SET_WORK_SCHEDULES,
  payload: workSchedules,
})

export const setWorkSchedulesLoaded = (
  loaded: boolean
): WorkScheduleAction => ({
  type: SET_WORK_SCHEDULES_LOADED,
  payload: loaded,
})

export const loadWorkSchedules = (): ThunkAction<
  void,
  RootState,
  null,
  WorkScheduleAction
> => {
  return async (dispatch) => {
    try {
      dispatch(setWorkSchedulesLoaded(false))
      const resp = await workScheduleApi.getWorkSchedules()
      dispatch(setWorkSchedules(resp.data.data))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await workScheduleApi.getWorkSchedules()
        dispatch(setWorkSchedules(resp.data.data))
      }
    } finally {
      dispatch(setWorkSchedulesLoaded(true))
    }
  }
}

export const setSelectedWorkSchedule = (
  workSchedule?: WorkScheduleEntity
): WorkScheduleAction => ({
  type: SET_SELECTED_WORK_SCHEDULE,
  payload: workSchedule,
})

export const setWorkScheduleFilter = (
  workScheduleFilter: WorkScheduleFilter
): WorkScheduleAction => ({
  type: SET_WORK_SCHEDULE_FILTER,
  payload: workScheduleFilter,
})
